export class Headers {
  static CONTENT_TYPE = 'Content-Type';
}
